var _rect, _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYellowCircleExclamationMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FF8A00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.114 13.965C11.114 14.4538 11.5102 14.85 11.999 14.85C12.4878 14.85 12.884 14.4538 12.884 13.965V6.765C12.884 6.27623 12.4878 5.88 11.999 5.88C11.5102 5.88 11.114 6.27623 11.114 6.765V13.965ZM10.88 17.628C10.88 18.2287 11.3243 18.774 12.044 18.774C12.6807 18.774 13.118 18.2211 13.118 17.628C13.118 17.1011 12.6755 16.554 12.044 16.554C11.3297 16.554 10.88 17.0937 10.88 17.628Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.24
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowCircleExclamationMark);
export default __webpack_public_path__ + "static/media/yellow-circle-exclamation-mark.2cc29d56c0ce026243720d7e4a173c87.svg";
export { ForwardRef as ReactComponent };